import { mapListToRecords, normalizeList } from '@sophocles/entities/entityUtils';
import { IssueCategory, issueCategorySchema } from '@sophocles/entities/IssueCategory/issueCategoryRecord';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';
import { fromJS } from 'immutable';
import { normalize } from 'normalizr';

/* Receive Actions */
export const RECEIVE_ISSUE_CATEGORIES = 'RECEIVE_ISSUE_CATEGORIES';
export function receiveIssueCategories(json) {
  return {
    type: RECEIVE_ISSUE_CATEGORIES,
    issueCategories: mapListToRecords(json, IssueCategory),
  };
}

/* Request Actions */
// starter request
export const REQUEST_ISSUE_CATEGORY = 'REQUEST_ISSUE_CATEGORY';
function requestIssueCategory(issueCategory_id) {
  return {
    type: REQUEST_ISSUE_CATEGORY,
    issueCategory_id,
  };
}

/* Fetch Actions */
// starter fetch

export function fetchIssueCategory(issueCategory_id) {
  return dispatch => {
    dispatch(requestIssueCategory(issueCategory_id));
    return apiClient
      .get(`/issuecategories/${issueCategory_id}/`, { params: { limit: 10000 } })
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data, 'issueCategories', issueCategorySchema))
      .then(json => dispatch(receiveIssueCategories(json.entities.issueCategories)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_ISSUE_CATEGORY)));
  };
}

export function fetchAllCategories() {
  return dispatch => {
    dispatch(requestIssueCategory());
    return apiClient
      .get('/issuecategories/', { params: { limit: 10000 } })
      .then(checkHttpStatus)
      .then(response => fromJS(response.data))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_ISSUE_CATEGORY)));
  };
}

/* Edit Actions */
export const EDIT_ISSUE_CATEGORY = 'EDIT_ISSUE_CATEGORY';
export function editIssueCategory(issueCategory_id) {
  return {
    type: EDIT_ISSUE_CATEGORY,
    issueCategory: issueCategory_id,
  };
}

export function patchIssueCategory(issueCategory_id, values) {
  return dispatch => {
    dispatch(editIssueCategory(issueCategory_id));
    return apiClient
      .patch(`/issuecategories/${issueCategory_id}/?limit=10000`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, issueCategorySchema))
      .then(json => dispatch(receiveIssueCategories(json.entities.issueCategories)))
      .catch(error => dispatch(genericErrorAction(error, EDIT_ISSUE_CATEGORY)));
  };
}

/* Create Actions */
export const CREATE_ISSUE_CATEGORY = 'CREATE_ISSUE_CATEGORY';
function sayCreateIssueCategory(values) {
  return {
    type: CREATE_ISSUE_CATEGORY,
    values: values,
  };
}

export function createIssueCategory(values) {
  return dispatch => {
    dispatch(sayCreateIssueCategory(values));
    return apiClient
      .post(`/issuecategories/?limit=10000`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, issueCategorySchema))
      .then(json => dispatch(receiveIssueCategories(json.entities.issueCategories)))
      .catch(error => dispatch(genericErrorAction(error, CREATE_ISSUE_CATEGORY)));
  };
}

/* Delete Actions */
export const DELETE_ISSUE_CATEGORY = 'DELETE_ISSUE_CATEGORY';
function sayDeleteIssueCategory(issueCategory_id) {
  return {
    type: DELETE_ISSUE_CATEGORY,
    issueCategory: issueCategory_id,
  };
}

export function deleteIssueCategory(issueCategory_id) {
  return dispatch =>
    apiClient
      .delete(`/issuecategories/${issueCategory_id}/?limit=10000`)
      .then(checkHttpStatus)
      .then(r => dispatch(sayDeleteIssueCategory(issueCategory_id)))
      .catch(error => dispatch(genericErrorAction(error, DELETE_ISSUE_CATEGORY)));
}
